import { render, staticRenderFns } from "./AdminCreateDepositBankAccountDialog.vue?vue&type=template&id=7dd67c37&"
import script from "./AdminCreateDepositBankAccountDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminCreateDepositBankAccountDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports